import { createGlobalStyle } from "styled-components";
import IRANYekanMobileRegular from "assets/fonts/IranYekan/IRANYekanMobileRegular.woff2";
import IRANYekanMobileLight from "assets/fonts/IranYekan/IRANYekanMobileLight.woff2";
import IRANYekanMobileMedium from "assets/fonts/IranYekan/IRANYekanMobileMedium.woff2";
import IRANYekanMobileExtraBold from "assets/fonts/IranYekan/IRANYekanMobileExtraBold.woff2";
import IRANYekanMobileBlack from "assets/fonts/IranYekan/IRANYekanMobileBlack.woff2";
import IRANYekanMobileThin from "assets/fonts/IranYekan/IRANYekanMobileThin.woff2";
import IRANYekanMobileExtraBlack from "assets/fonts/IranYekan/IRANYekanMobileExtraBlack.woff2";
import IRANYekanMobileBold from "assets/fonts/IranYekan/IRANYekanMobileBold.woff2";
const GlobalStyle = createGlobalStyle`
  :root{
   
     --primary-50:#f0f7ff;
     --primary-100:#d1e6ff;
     --primary-200:#bbdaff;
     --primary-300:#9dc9ff;
     --primary-400:#89beff;
     --primary-500:#6caeff;
     --primary-600:#629ee8;
     --primary-700:#4d7cb5;
     --primary-800:#3b608c;
     --primary-900:#2d496b;
    
     --secondary-50:#f9fafe;
     --secondary-100:#ebeefb;
     --secondary-200:#e2e6f9;
     --secondary-300:#d4dbf7;
     --secondary-400:#ccd4f5;
     --secondary-500:#bfc9f3;
     --secondary-600:#aeb7dd;
     --secondary-700:#888fad;
     --secondary-800:#696f86;
     --secondary-900:#505466;
    
     --tertiary-50:#fffde7;
     --tertiary-100:#fff7b3;
     --tertiary-200:#fff48e;
     --tertiary-300:#ffee5b;
     --tertiary-400:#ffeb3b;
     --tertiary-500:#ffe60a;
     --tertiary-600:#e8d109;
     --tertiary-700:#b5a307;
     --tertiary-800:#8c7f06;
     --tertiary-900:#6b6104;
     
     --text-50:#e9eef4;
     --text-100:#bccadb;
     --text-200:#9cb0ca;
     --text-300:#6e8cb2;
     --text-400:#5276a3;
     --text-500:#27548c;
     --text-600:#234c7f;
     --text-700:#1c3c63;
     --text-800:#152e4d;
     --text-900:#10233b;
     
     --error-50:#ffecec;
     --error-100:#ffc3c3;
     --error-200:#ffa6a6;
     --error-300:#ff7d7d;
     --error-400:#ff6464;
     --error-500:#ff3d3d;
     --error-600:#e83838;
     --error-700:#b52b2b;
     --error-800:#8c2222;
     --error-900:#6b1a1a;
     
     --success-50:#f0faea;
     --success-100:#d0d0bf;
     --success-200:#b9e89f;
     --success-300:#99de74;
     --success-400:#85d759;
     --success-500:#67cd2f;
     --success-600:#5ebb2b;
     --success-700:#499221;
     --success-800:#39711a;
     --success-900:#2b5614;
     
     --gray-50:#f3f3f4;
     --gray-100:#d9dbde;
     --gray-200:#c7c9ce;
     --gray-300:#aeb1b8;
     --gray-400:#9ea1aa;
     --gray-500:#868a95;
     --gray-600:#7a7e88;
     --gray-700:#5f626a;
     --gray-800:#4a4c52;
     --gray-900:#383a3f;
    
     --bg-disable:#f4f7fc;
     --bg-gray:#e9ebf8;
     --bg-black:#0e1621;
     --bg-white:#ffffff;
  }
   
  @font-face {
    font-family: "IRANYekanMobileFN";
    src: url(${IRANYekanMobileThin}) format('woff2');
    font-weight: 100;
    font-style: normal;
}
  @font-face {
    font-family: "IRANYekanMobileFN";
    src: url(${IRANYekanMobileLight}) format('woff2');
    font-weight: 300;
    font-style: normal;
}

@font-face {
    font-family: "IRANYekanMobileFN";
    src: url(${IRANYekanMobileRegular}) format('woff2');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: "IRANYekanMobileFN";
    src: url(${IRANYekanMobileMedium}) format('woff2');
    font-weight: 500;
    font-style: normal;
}
@font-face {
    font-family: "IRANYekanMobileFN";
    src: url(${IRANYekanMobileBold}) format('woff2');
    font-weight: 700;
    font-style: normal;
}
@font-face {
    font-family: "IRANYekanMobileFN";
    src: url(${IRANYekanMobileExtraBold}) format('woff2');
    font-weight: 800;
    font-style: normal;
}
@font-face {
    font-family: "IRANYekanMobileFN";
    src: url(${IRANYekanMobileBlack}) format('woff2');
    font-weight: 900;
    font-style: normal;
}
@font-face {
    font-family: "IRANYekanMobileFN";
    src: url(${IRANYekanMobileExtraBlack}) format('woff2');
    font-weight: 950;
    font-style: normal;
}
 
*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    transition: 0.3s;
}
html{
    font-family: "IRANYekanMobileFN";
}
input , input::placeholder, button , a, select{
    font-family: "IRANYekanMobileFN";
}
/* input:-internal-autofill-selected{
   -webkit-background-color: red !important;
} */
a {
   text-decoration: none;
}
ul {
  list-style-type: none;
}

`;
export default GlobalStyle;
